var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWinatvRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 40,
    viewBox: "0 0 55 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1516_180358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9237 0L26.2717 13.7392H23.9198L21.3183 0H14.8122L12.2106 13.7392H9.85766L7.20574 0H0L2.90265 13.7392H0V21.2341H4.50345L7.4061 34.9734H13.9122L16.8137 21.2341H19.3157L22.2183 34.9734H28.7244L31.626 21.2341H36.1305V13.7392H33.2278L36.1305 0H28.9237Z",
    fill: "#E50914"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.828 23.7632L30.3418 39.9999L42.5184 38.3141L42.2363 39.4667L51.5613 38.5721L55.0006 22.7986L45.9483 24.1297L46.3948 22.1389L33.828 23.7632Z",
    fill: "#E50914"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5977 28.1457L44.9447 27.73L44.8888 30.3911C44.9418 31.5943 44.8888 32.7711 44.9418 33.9919H45.0154C45.6277 32.6891 46.1369 31.4508 46.7257 30.1686L49.0807 24.8991L52.3189 24.4922L46.1752 36.6324L42.3483 37.1125L41.5977 28.1457Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3182 25.3537L34.7363 27.9279L37.864 27.5328L35.8623 36.5776L38.9871 36.1854L40.8578 27.774L39.9006 27.2626L41.9925 27.0156L44.1252 26.7454L44.7071 24.1711L35.3182 25.3537Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1516_180358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinatvRed);
export default __webpack_public_path__ + "static/media/winatv_red.eb210fb6a9ed746d7b78f05414c8778b.svg";
export { ForwardRef as ReactComponent };